<template>
  <form ref="form">
    <template v-for="(location, index) in locationsArray" v-bind:key="index">
      <section class="container-fluid white-box mb-4">
        <div class="row" :id="`location-${index}`">
          <div class="col-md-12">
            <h2>Location Details</h2>
            <p class="sub-text">Tell us about your business location.</p>
          </div>
          <div class="col-sm-12 form-group">
            <input
              v-model="location.name"
              required
              type="LocationName"
              class="form-control"
              id="LocationName"
              aria-describedby="LocationName"
              placeholder="Location Name"
            />
          </div>
          <div class="col-md-12 form-group">
            <input
              v-model="location.phone"
              required
              type="tel"
              class="form-control"
              id="owner-phonenumber"
              aria-describedby="phoneNumber"
              placeholder="Phone Number"
            />
          </div>
          <!-- Address -->
          <div class="col-sm-12 form-group">
            <input
              v-model="location.address_line1"
              required
              type="LocationAddress"
              class="form-control"
              id="LocationAddress"
              aria-describedby="LocationAddress"
              placeholder="Location Address"
            />
          </div>
          <div class="col-sm-12 form-group">
            <input
              v-model="location.address_line2"
              type="unit-number"
              class="form-control"
              id="unit-number"
              aria-describedby="unit-number"
              placeholder="Apartment, Studio, Unit Number (Optional)"
            />
          </div>
          <div class="col-sm-6 form-group">
            <input
              v-model="location.city"
              required
              type="city"
              class="form-control"
              id="city"
              aria-describedby="city"
              placeholder="City"
            />
          </div>
          <div class="col-sm-3 form-group">
            <input
              v-model="location.state"
              required
              type="state"
              class="form-control"
              id="state"
              aria-describedby="state"
              placeholder="State"
            />
          </div>
          <div class="col-sm-3 form-group">
            <input
              v-model="location.zipcode"
              required
              type="zipcode"
              class="form-control"
              id="zipcode"
              aria-describedby="zipcode"
              placeholder="Zipcode"
            />
          </div>

          <!-- Shipping-->
          <div class="col-sm-12 form-group mb-0">
            <h3>Shipping Details</h3>
            <div class="form-check form-check-inline my-0">
              <input
                v-model="location.shipping_the_same"
                class="form-check-input"
                type="checkbox"
                :name="`shipping_the_same-${index}`"
                :id="`shipping_the_same-${index}`"
              />
              <label
                class="form-check-label"
                :for="`shipping_the_same-${index}`"
              >
                Shipping address is same as the location address
              </label>
            </div>
          </div>

          <template v-if="!location.shipping_the_same">
            <div class="col-sm-12 form-group">
              <input
                v-model="location.shipping_line1"
                required
                class="form-control"
                id="shipping_line1"
                placeholder="Address"
              />
            </div>
            <div class="col-sm-12 form-group">
              <input
                v-model="location.shipping_line2"
                class="form-control"
                id="shipping_line2"
                placeholder="Apartment, Studio, Unit Number (Optional)"
              />
            </div>
            <div class="col-sm-6 form-group">
              <input
                v-model="location.shipping_city"
                required
                class="form-control"
                id="shipping_city"
                aria-describedby="city"
                placeholder="City"
              />
            </div>
            <div class="col-sm-3 form-group">
              <input
                v-model="location.shipping_state"
                required
                class="form-control"
                id="shipping_state"
                aria-describedby="state"
                placeholder="State"
              />
            </div>
            <div class="col-sm-3 form-group">
              <input
                v-model="location.shipping_zipcode"
                required
                class="form-control"
                id="shipping_zipcode"
                aria-describedby="zipcode"
                placeholder="Zipcode"
              />
            </div>
          </template>

          <div class="col-sm-12 form-group">
            <h3>Deployment Details</h3>
          </div>

          <!--Restaurant Type-->
          <div class="col-sm-12 form-group">
            <div class="form-check form-check-inline mr-4">
              <input
                v-model="location.type"
                required
                @click="location.kiosk_type = undefined"
                :name="`type-${index}`"
                class="form-check-input"
                type="radio"
                :id="`Brick-and-Mortar-${index}`"
                value="Brick + Mortar"
              />
              <label class="form-check-label" :for="`Brick-and-Mortar-${index}`"
                >Brick and Mortar</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                v-model="location.type"
                required
                @click="location.kiosk_type = undefined"
                class="form-check-input"
                type="radio"
                :name="`type-${index}`"
                :id="`Food-Truck-${index}`"
                value="Food Truck"
              />
              <label class="form-check-label" :for="`Food-Truck-${index}`"
                >Food Truck</label
              >
            </div>
          </div>

          <!--Revi Device Type-->
          <div class="col-sm-12 kiosk-type-options">
            <p class="bold">Revi Device Type</p>
            <div class="container-fluid container-kiosk-type">
              <div class="row kiosk-type-row">
                <div class="form-check form-check-inline standing">
                  <input
                    v-model="location.kiosk_type"
                    required
                    class="form-check-input"
                    type="radio"
                    :name="`kiosk-${index}`"
                    :id="`model-standing-kiosk-${index}`"
                    value="STANDING"
                  />
                  <label
                    class="outer-box ratio-box-1-1 form-check-label"
                    :for="`model-standing-kiosk-${index}`"
                  >
                    <img src="../assets/kiosk-standing.svg" />
                  </label>
                  <p>Standing</p>
                </div>
                <div class="form-check form-check-inline countertop">
                  <input
                    v-model="location.kiosk_type"
                    required
                    class="form-check-input"
                    type="radio"
                    :name="`kiosk-${index}`"
                    :id="`model-countertop-kiosk-${index}`"
                    value="COUNTER_TOP"
                  />
                  <label
                    class="outer-box ratio-box-1-1 form-check-label"
                    :for="`model-countertop-kiosk-${index}`"
                  >
                    <img src="../assets/kiosk-counter-top.svg" />
                  </label>
                  <p>Counter Top</p>
                </div>
                <div
                  v-if="
                    location.type === 'Food Truck' ||
                    location.type === undefined
                  "
                  class="form-check form-check-inline clamp"
                >
                  <input
                    v-model="location.kiosk_type"
                    required
                    class="form-check-input"
                    type="radio"
                    :name="`kiosk-${index}`"
                    :id="`model-clamp-kiosk-${index}`"
                    value="CLAMP"
                  />
                  <label
                    class="outer-box ratio-box-1-1 form-check-label"
                    :for="`model-clamp-kiosk-${index}`"
                  >
                    <img src="../assets/kiosk-clamp.svg" />
                  </label>
                  <p>Clamp</p>
                </div>
                <div class="form-check form-check-inline countertop">
                  <input
                    v-model="location.kiosk_type"
                    required
                    class="form-check-input"
                    type="radio"
                    :name="`kiosk-${index}`"
                    :id="`model-order-ahead-${index}`"
                    value="ORDER_AHEAD"
                  />
                  <label
                    class="outer-box ratio-box-1-1 form-check-label"
                    :for="`model-order-ahead-${index}`"
                  >
                    <img
                      src="../assets/order-ahead.png"
                      class="order-ahead-img"
                    />
                  </label>
                  <p>Order Ahead</p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-sm-12 d-flex justify-content-between align-items-center form-group"
            v-if="!isOrderAhead(location)"
          >
            <p class="bold">Credit Card Reader</p>
            <p>Included</p>
          </div>
          <div
            class="col-sm-12 d-flex justify-content-between align-items-center form-group mb-3"
          >
            <p class="bold">Kitchen Tablet</p>
            <p>Included</p>
          </div>
          <!-- Online Order Management -->
          <div class="col-sm-12 form-group d-flex justify-content-between mb-0">
            <div class="form-check form-check-inline">
              <input
                v-model="location.kit_online_order_management"
                class="form-check-input"
                type="checkbox"
                name="kit_online_order_management"
                :id="`kit_online_order_management-${index}`"
              />
              <p class="bold m-auto">
                <label
                  class="form-check-label checkbox-support-text"
                  :for="`kit_online_order_management-${index}`"
                >
                  Online Order Management</label
                >
              </p>
            </div>
            <p class="my-auto">
              ${{ monthly("kit_online_order_management") }}/mo
            </p>
          </div>
          <span class="sub-text ml-4 mb-3"
            >(consolidate all online orders to one tablet)</span
          >

          <!-- Additional KIT -->
          <div
            class="col-sm-12 d-flex justify-content-between align-items-center form-group mb-3"
          >
            <p class="bold my-auto">
              Additional Kitchen Tablet - ${{ price("additional_tablet") }} each
            </p>
            <select
              v-model="location.additional_kitchen_tablet_count"
              class="custom-select"
              id="number-of-tablets"
              required=""
            >
              <option value="0">0</option>
              <option v-for="i in 50" :value="i">{{ i }}</option>
            </select>
          </div>

          <!-- 4G Support -->
          <div class="col-sm-12 form-group d-flex justify-content-between mb-3">
            <div class="form-check form-check-inline">
              <input
                v-model="location.kitchen_tablet_4g_support"
                class="form-check-input"
                type="checkbox"
                name="tablet_4g"
                :id="`tablet_4g-${index}`"
              />
              <p class="bold m-auto">
                <label
                  class="form-check-label checkbox-support-text"
                  :for="`tablet_4g-${index}`"
                >
                  4G Support for Kitchen Tablet</label
                >
              </p>
            </div>
            <p class="my-auto">${{ monthly("4g_support") }}/mo</p>
          </div>

          <!-- Revi POS -->
          <div
            v-if="!isOrderAhead(location)"
            class="col-sm-12 form-group d-flex justify-content-between mb-0"
            @click="openPosPlanForm(index)"
          >
            <div class="form-check form-check-inline">
              <input
                v-model="location.pos_plan_checked"
                class="form-check-input"
                type="checkbox"
                name="pos_plan"
                :id="`pos_plan-${index}`"
              />
              <p class="bold m-auto">
                <label
                  class="form-check-label checkbox-support-text"
                  :for="`pos_plan-${index}`"
                >
                  Revi POS {{ reviPosPlanName(location) }}
                </label>
              </p>
            </div>
            <p class="my-auto">{{ reviPosPlanPrice(location) }}</p>
          </div>

          <!-- 4G Support for POS -->
          <div
            v-if="!isOrderAhead(location)"
            class="col-sm-12 form-group d-flex justify-content-between mb-3"
          >
            <div class="form-check form-check-inline">
              <input
                :disabled="!location.pos_plan_checked"
                v-model="location.pos_4g_support"
                class="form-check-input"
                type="checkbox"
                name="pos_4g_support"
                :id="`pos_4g_support-${index}`"
              />
              <p class="bold m-auto">
                <label
                  class="form-check-label checkbox-support-text"
                  :for="`pos_4g_support-${index}`"
                >
                  {{ name("4g_support_pos") }}
                </label>
              </p>
            </div>
            <p class="my-auto">${{ monthly("4g_support_pos") }}/mo</p>
          </div>

          <!-- Expedited Support -->
          <div class="col-sm-12 form-group d-flex justify-content-between mb-3">
            <div class="form-check form-check-inline">
              <input
                v-model="location.expedited_support"
                class="form-check-input"
                type="checkbox"
                name="expedited_support"
                :id="`expedited_support-${index}`"
              />
              <p class="bold m-auto">
                <label
                  class="form-check-label checkbox-support-text"
                  :for="`expedited_support-${index}`"
                >
                  {{ name("expedited_support") }}
                </label>
              </p>
            </div>
            <p class="my-auto">${{ monthly("expedited_support") }}/mo</p>
          </div>

          <!-- Ticket Printer -->
          <div
            class="col-sm-12 d-flex justify-content-between align-items-center form-group"
          >
            <p class="bold">
              Ticket Printer - ${{ price("ticket_printer") }} each
            </p>
            <div class="">
              <select
                v-model="location.ticket_printer_count"
                class="custom-select"
                id="number-of-printers"
                required=""
              >
                <option value="0">0</option>
                <option v-for="i in 50" :value="i">{{ i }}</option>
              </select>
            </div>
          </div>

          <!-- Revi Delivery -->
          <div class="col-sm-12 form-group d-flex justify-content-between mb-3">
            <div class="form-check form-check-inline">
              <input
                v-model="location.delivery_enabled"
                class="form-check-input"
                type="checkbox"
                name="delivery_enabled"
                :id="`delivery_enabled-${index}`"
              />
              <p class="bold m-auto">
                <label
                  class="form-check-label checkbox-support-text"
                  :for="`delivery_enabled-${index}`"
                >
                  Revi Delivery
                </label>
              </p>
            </div>
            <p class="my-auto">Flat Fee</p>
          </div>
          <!-- Remove or Back/Next -->
          <div class="col-md-12 d-flex justify-content-end">
            <!-- Remove Location -->
            <div
              v-if="index !== 0 || locationsArray.length > 1"
              class="col-md-7 d-flex justify-content-end align-items-center p-0"
            >
              <div
                class="add-location d-flex justify-content-center justify-content-sm-start align-items-center flex-grow-1"
                @click="removeLocation(index)"
              >
                <div class="circle-plus">
                  <i class="fas fa-minus"></i>
                </div>
                <p class="bold ml-2 mb-0">Remove Location</p>
              </div>
            </div>

            <!-- Back / Next -->
            <div
              class="col-md-5 d-flex align-items-center justify-content-end p-0"
            >
              <button
                v-if="index + 1 === locationsArray.length"
                class="back-button dark-button m-0"
                type="button"
                name="next"
                @click="$emit('back-clicked', locationsArray)"
              >
                Back
              </button>
              <button
                v-if="index + 1 === locationsArray.length"
                class="next-button m-0"
                type="button"
                name="next"
                @click="next"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </section>
    </template>

    <!-- Add Location -->
    <section class="container-fluid white-box">
      <div class="justify-content-center d-flex align-items-center">
        <div class="col-md-6 d-flex align-items-center p-0">
          <div
            class="add-location d-flex align-items-center flex-grow-1 justify-content-start"
            @click="addLocation"
          >
            <div class="circle-plus">
              <i class="fas fa-plus"></i>
            </div>
            <p class="bold ml-2 mb-0">Add Another Location</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Modals -->
    <ReviPOSPlanModal
      v-if="posPlanModalLocationIndex !== undefined"
      @cancel-clicked="posPlanCancelClicked"
      @ok-clicked="posPlanOkClicked"
      :prices="prices"
      :values="posPlanModalValues"
    ></ReviPOSPlanModal>
  </form>
</template>

<script>
import ReviPOSPlanModal from "@/components/ReviPOSPlanModal";
import { monthly, name, price } from "@/utils/prices";

const TYPE_BRICK_MORTAR = "Brick + Mortar";

function emptyLocation() {
  return {
    name: undefined,
    phone: undefined,
    type: TYPE_BRICK_MORTAR,
    kiosk_type: undefined,
    additional_kitchen_tablet_count: 0,
    kit_online_order_management: false,
    kitchen_tablet_4g_support: false,
    ticket_printer_count: 0,
    pos_plan: undefined,
    pos_payment_schedule: undefined,
    pos_plan_checked: false,
    pos_4g_support: false,
    expedited_support: false,
    // Location address
    address_line1: undefined,
    address_line2: undefined,
    city: undefined,
    state: undefined,
    zipcode: undefined,
    // Shipping address
    shipping_the_same: false,
    shipping_line1: undefined,
    shipping_line2: undefined,
    shipping_city: undefined,
    shipping_state: undefined,
    shipping_zipcode: undefined,
    delivery_enabled: true,
  };
}

export default {
  name: "LocationDetailsPage",
  components: { ReviPOSPlanModal },
  props: {
    locations: Array,
    prices: Array,
    error: Function,
  },
  data() {
    let locations = this.locations;
    if (locations.length === 0) {
      locations = [emptyLocation()];
    }
    return {
      locationsArray: locations,
      posPlanModalLocationIndex: undefined,
      posPlanModalValues: undefined,
    };
  },
  methods: {
    next() {
      if (this.kioskTypesNotChosen.length !== 0) {
        const locations = this.kioskTypesNotChosen;
        this.error(
          'Please choose "Revi Device Type" for the location: ' +
            locations.map((x) => x.name)
        );
        return;
      }
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        return;
      }
      this.$emit("next-clicked", this.locationsArray);
    },
    addLocation() {
      this.locationsArray.push(emptyLocation());
      const index = this.locationsArray.length - 1;
      // Scroll to the new location
      this.$nextTick().then(function () {
        const locationDiv = document.getElementById(`location-${index}`);
        locationDiv.scrollIntoView();
      });
    },
    removeLocation(index) {
      this.locationsArray.splice(index, 1);
    },
    async load() {},
    price(key) {
      return price(this.prices, key);
    },
    monthly(key) {
      return monthly(this.prices, key);
    },
    name(key) {
      return name(this.prices, key);
    },
    openPosPlanForm(index) {
      const checked = this.locationsArray[index].pos_plan_checked;
      console.log(checked);
      if (checked) {
        this.locationsArray[index].pos_plan_checked = false;
        this.locationsArray[index].pos_plan = undefined;
        this.locationsArray[index].pos_payment_schedule = undefined;
        this.locationsArray[index].pos_4g_support = false;
      } else {
        this.posPlanModalLocationIndex = index;
        this.posPlanModalValues = this.locationsArray[index];
      }
    },
    posPlanCancelClicked() {
      if (!this.locationsArray[this.posPlanModalLocationIndex].pos_plan) {
        this.locationsArray[
          this.posPlanModalLocationIndex
        ].pos_plan_checked = false;
      }
      this.posPlanModalLocationIndex = undefined;
    },
    posPlanOkClicked(data) {
      this.locationsArray[this.posPlanModalLocationIndex].pos_plan =
        data.pos_plan;
      this.locationsArray[this.posPlanModalLocationIndex].pos_payment_schedule =
        data.pos_payment_schedule;
      this.locationsArray[
        this.posPlanModalLocationIndex
      ].pos_plan_checked = true;
      this.locationsArray[this.posPlanModalLocationIndex].pos_4g_support =
        data.pos_4g_support;
      this.posPlanModalLocationIndex = undefined;
    },
    reviPosPlanName(location) {
      if (location.pos_plan === "sampler") {
        return "- Sampler";
      }
      if (location.pos_plan === "regular") {
        return "- Business Regular";
      }
      if (location.pos_plan === "patron") {
        return "- Business Patron";
      }
      return "";
    },
    reviPosPlanPrice(location) {
      if (!location.pos_plan) {
        return "-";
      }
      const key = `revi_pos_plan_${location.pos_plan}_${location.pos_payment_schedule}`;
      if (location.pos_payment_schedule === "upfront") {
        return `$${price(this.prices, key)}`;
      } else {
        return `$${monthly(this.prices, key)}/mo`;
      }
    },
    isOrderAhead(location) {
      return location.kiosk_type === "ORDER_AHEAD";
    },
  },
  mounted() {},
  created() {},
  computed: {
    kioskTypesNotChosen() {
      //  Return list of locations without chosen kiosk type field.
      return this.locationsArray.filter((x) => x.kiosk_type === undefined);
    },
  },
  watch: {},
};
</script>

<style scoped>
button {
  /* margin-left: 24px;
  margin-top: 24px; */
  margin-left: 2.22vh;
  margin-top: 2.22vh;
}

.container-fluid {
  /* margin-bottom: 75px; */
}

.container-kiosk-type {
  margin-top: 16px;
}

.kiosk-type-row {
  /* display: flex;
  flex-direction: row;
  justify-content: space-between; */
}

.kiosk-type-row input[type="radio"] {
  display: none;
}

.kiosk-type-row .form-check {
  width: 31%;
  margin: 0px;
}

.kiosk-type-row .form-check:nth-child(1),
.kiosk-type-row .form-check:nth-child(2) {
  margin-right: 3.5%;
}

.kiosk-type-row input:checked + label,
.kiosk-type-row label:hover {
  cursor: pointer;
  box-shadow: 0 0px 3px #ff4f21, 0px 3px 6px #00000029;
}

/* Ratio 1:1  */
.ratio-box-1-1 {
  position: relative;
  width: 100%;
}

.ratio-box-1-1:before {
  content: " ";
  display: block;
  padding-bottom: calc(100% / 1 * 1);
}

.kiosk-type-row label {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
}

.kiosk-type-row label img {
  padding: 16px;
  /* height: 100%; */
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.kiosk-type-row .form-check {
  display: flex;
  flex-direction: column;
}

.kiosk-type-row .form-check p {
  padding-top: 12px;
}

.kiosk-type-row .countertop label {
}

.kiosk-type-row .clamp label {
}

select {
  margin-bottom: 0px;
}

.circle-plus {
  border-radius: 50%;
  background-color: #f6f7fb;
  box-shadow: 0px 4px 5px #00000033;
}

.circle-plus:hover {
  background-color: #ff4f21;
  cursor: pointer;
  /*box-shadow: 0px 4px 5px #00000033;*/
}

.fa-minus {
  margin: 1.7vh;
  color: #bfc4cd;
  font-size: 2.22vh;
}

.fa-plus {
  margin: 1.7vh;
  color: #bfc4cd;
  font-size: 2.22vh;
}

.custom-select {
  width: 5em;
  height: 6vh;
}

.custom-select:focus {
  color: rgb(73, 80, 87);
}

.buttons-right {
  display: flex;
  flex-direction: row;
  width: fit-content;
}

.kiosk-type-options {
  margin-bottom: 2em;
}

@media (max-width: 1199.99px) {
  .checkbox-support-text {
    padding-left: 16px;
    max-width: 60%;
  }
}

.order-ahead-img {
  width: 100px;
  padding-left: 24px !important;
}
</style>
